import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";
import Typography from "@mui/material/Typography";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ToolTip from "../tooltip";

const PasswordStrengthBar = ({ password, sx }) => {
	const [score, setScore] = useState(0);
	const { t } = useTranslation();

	useEffect(() => {
		const passwordScore = calculatePasswordScore(password);
		setScore(passwordScore);
	}, [password]);

	let scoreResult;
	switch (score) {
		case 1:
			scoreResult = {
				color: "error",
				translation: t("sign_up.form.password_strength.bad"),
				value: 25,
			};
			break;
		case 2:
			scoreResult = {
				color: "error",
				translation: t("sign_up.form.password_strength.medium"),
				value: 50,
			};
			break;
		case 3:
			scoreResult = {
				color: "warning",
				translation: t("sign_up.form.password_strength.okay"),
				value: 75,
			};
			break;
		case 4:
			scoreResult = {
				color: "success",
				translation: t("sign_up.form.password_strength.good"),
				value: 100,
			};
			break;
		default:
			scoreResult = {
				color: "error",
				translation: t("sign_up.form.password_strength.too_short"),
				value: 0,
			};
	}

	return (
		<Box sx={sx}>
			<LinearProgress
				variant="determinate"
				value={scoreResult.value}
				color={scoreResult.color}
				sx={{ borderRadius: 5 }}
			/>
			<Box display="flex" justifyContent="flex-end">
				<Typography variant="caption" sx={{ pt: 0.3 }} color={scoreResult.color}>
					{scoreResult.translation}
				</Typography>
				<ToolTip
					tip={t("validation.password.tooltip")}
					size="18px"
					sx={{
						color: scoreResult.color,
						ml: 0.5,
					}}
				/>
			</Box>
		</Box>
	);
};

const calculatePasswordScore = (password) => {
	if (!password) {
		return 0;
	}

	let score = 0;
	if (password.length >= 12) {
		score++;
	}
	if (/[a-z]/.test(password) && /[A-Z]/.test(password)) {
		score++;
	}
	if (/[0-9]/.test(password)) {
		score++;
	}
	if (/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/.test(password)) {
		score++;
	}

	return score;
};

export default PasswordStrengthBar;
